<template lang="pug">
  vm-prompt(@vm-cancel="close" vm-size="small" @vm-accept="salve" @vm-close="close" :vm-active="isModalUpdatePurchaseOrderVisible" :vm-title='title' :vm-show-buttons="false")
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          span {{ $t('projects.purchase_order') }}
          br
          br
          input(type="file" ref="file" v-on:change="handleFileUpdate()" accept="application/pdf")
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'ModalUpdatePurchaseOrder',
  props: {
    title: {
      type: String,
      default: 'Update Purchase Order'
    },
    form: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      file: ''
    }
  },
  computed: {
    ...mapGetters([
      'isModalUpdatePurchaseOrderVisible'
    ]),
    isFile () {
      return !this.file
    }
  },
  methods: {
    ...mapActions([
      'assignedPurchaseOrder',
      'setModalUpdatePurchaseOrderVisible'
    ]),
    salve () {
      if (this.$refs.file.files.length > 0) {
        this.$vm.dialog({
          color: 'danger',
          title: 'warning',
          text: this.$t('strings.update_purchase_order'),
          acceptText: this.$t('update'),
          accept: () => {
            this.assignedPurchaseOrder({ project_id: this.form.id, file: this.$refs.file.files[0] })
          }
        })
      } else {
        this.$vm.dialog({
          color: 'danger',
          title: 'No file',
          text: 'No file',
          acceptText: 'close'
        })
      }
    },
    close () {
      this.setModalUpdatePurchaseOrderVisible(false)
    }
  }
}
</script>

<style>
.vm-select--options {
  z-index: 400331 !important;
}
.image {
    width: 100%;
    height: 100%;
    background: #e4e4e4;
    box-sizing: content-box;
}
a {
  cursor: pointer;
}
</style>
